import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { CheckRegistrationStatusApiType, IDPatientListApi } from 'models/DCK/DCKApiTypes';

class HospitalAPI {
    async patientFind(rqData: CheckRegistrationStatusApiType, token: string): Promise<IDPatientListApi> {
        try {
            const response = await axios.post(apiPaths.patientFind, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const hospitalAPI = new HospitalAPI();
